import styled from 'styled-components';

export const StyledSahamDropDown = styled.div`
  width: 100%;
  position: relative;
  min-height: 36px;
`;

interface StyledDecisionDropDownProps {
  width?: string;
  height?: string;
  marginMenuList?: string;
  backgroundColor?: string;
  textColor?: string;
  iconColor?: string;
}

export const StyledDecisionDropDown = styled.div<StyledDecisionDropDownProps>`
  width: ${({ width }) => (width ? `${width}px` : '160px')};
  height: ${({ height }) => (height ? `${height}px` : '40px')};
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? `${backgroundColor}` : '#0075c9'};
  box-shadow: 0px 3px 6px #00000029;
  margin-left: auto;
  margin_right: 0px;
  border-radius: 4px;
  padding: 2px;
  .drop-down-icon {
    fill: ${({ iconColor }) => (iconColor ? `${iconColor}` : '#fff')};
  }
  .drop-down-button {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    width: 100%;
    color: ${({ textColor }) => (textColor ? `${textColor}` : '#fff')};
    text-transform: none;
  }

  .popper {
    margin-top: ${({ marginMenuList }) =>
      marginMenuList ? `${marginMenuList}px` : '5px'};
    transform: translate3d(0px, 40px, 0px);
    min-width: 145px;
    z-index: 100;
    background-color: #fafafa;
    box-shadow: 0px 2px 10px #00000033;
  }
`;
